import React from 'react'
import { useEffect } from 'react';
import { useState } from 'react'
import { ScaleLoader } from 'react-spinners'
import { AxiosPost } from '../../../../context/UserContext';
import { pushNotify } from '../../../../services/NotifyService';

function ViewTransactionInfo(props) {
    const [isLoading, setIsLoading] = useState(false)
    const [transaction, setTransaction] = useState(null);


    const fetchTransaction = async () => {
        try {
            setIsLoading(true);
            const data = await AxiosPost('fetch_transaction_info.php', { id: props.showInfo.id });
            console.log(data)
            if (data.success) {
                setTransaction(data)
            }
            else {
                pushNotify("error", "Error", data.error)
            }
        } catch {
            pushNotify("error", "Error", "Server Error!")
        } finally {
            setIsLoading(false)
        }
    }

    useEffect(() => {
        fetchTransaction()
    }, [])

    return (
        <>

            <div>
                <div className="col-xl-12 col-lg-12 col-xxl-12 col-sm-12">
                    <div className="card">
                        <div className="card-header border-0 pb-0" style={{ justifyContent: "left" }}>
                            <button class="btn btn-primary tp-btn sharp" onClick={() => { props.setShowInfo({ show: false, id: null }) }} ><i class="fas fa-arrow-left"></i></button>
                            <h4 className="card-title">Transaction Info</h4>
                        </div>
                        <div className="card-body" style={{ height: "calc(100vh - 18.5rem)" }}>
                            <div className="table-responsive recentOrderTable" style={{ height: "100%" }}>
                                {
                                    isLoading || transaction == null ?
                                        <div className="row mx-0" style={{ height: "100%" }}><ScaleLoader cssOverride={{ "display": "flex", "justifyContent": "center", "alignItems": "center" }} /></div> :
                                        <div className='basic-form'>
                                            <div className='row' style={{ margin: "0" }}>
                                                <div className='col-md-4'>
                                                    <label>Date</label>
                                                    <div className='form-control'>{transaction.transaction_info[0].created_at}</div>
                                                </div>
                                                <div className='col-md-4'>
                                                    <label>Voucher Number</label>
                                                    <div className='form-control'>{transaction.transaction_info[0].voucher_number}</div>
                                                </div>
                                                <div className='col-md-4'>
                                                    <label>Voucher Date</label>
                                                    <div className='form-control'>{transaction.transaction_info[0].voucher_date}</div>
                                                </div>
                                                <div className='col-md-4'>
                                                    <label>Invoice Date</label>
                                                    <div className='form-control'>{transaction.transaction_info[0].invoice_date}</div>
                                                </div>
                                                <div className='col-md-4'>
                                                    <label>Invoice Number</label>
                                                    <div className='form-control'>{transaction.transaction_info[0].invoice_number}</div>
                                                </div>
                                                <div className='col-md-4'>
                                                    <label>Vendor Name</label>
                                                    <div className='form-control'>{transaction.transaction_info[0].vendor_name}</div>
                                                </div>
                                                <div className='col-md-4'>
                                                    <label>Under Head</label>
                                                    <div className='form-control'>{transaction.transaction_info[0].under_head}</div>
                                                </div>
                                                <div className='col-md-4'>
                                                    <label>Bill Type</label>
                                                    <div className='form-control'>{transaction.transaction_info[0].bill_type}</div>
                                                </div>
                                            </div>
                                            <div style={{ marginTop: "10px" }}><h4>Names</h4></div>
                                            <div className='row' style={{ margin: "0" }}>
                                                {Array.from({ length: transaction.transaction_names.length }).map((it, index) => (
                                                    <div className='row'>
                                                        <div className='col-md-4'>
                                                            <label>Name</label>
                                                            <div className='form-control'>{transaction.transaction_names[index].name}</div>
                                                        </div>
                                                        <div className='col-md-4'>
                                                            <label>Category</label>
                                                            <div className='form-control'>{transaction.transaction_names[index].category_desc}</div>
                                                        </div>
                                                        <div className='col-md-4'>
                                                            <label>Department</label>
                                                            <div className='form-control'>{transaction.transaction_names[index].department}</div>
                                                        </div>
                                                        <div className='col-md-4'>
                                                            <label>Designation</label>
                                                            <div className='form-control'>{transaction.transaction_names[index].designation}</div>
                                                        </div>
                                                        <div className='col-md-4'>
                                                            <label>Type</label>
                                                            <div className='form-control'>{transaction.transaction_names[index].bill_type}</div>
                                                        </div>
                                                        <div className='col-md-4'>
                                                            <label>Amount</label>
                                                            <div className='form-control'>{transaction.transaction_names[index].amount}</div>
                                                        </div>
                                                        <div className='col-md-4'>
                                                            <label>gst</label>
                                                            <div className='form-control'>{transaction.transaction_names[index].gst}</div>
                                                        </div>
                                                        <div className='col-md-4'>
                                                            <label>tds</label>
                                                            <div className='form-control'>{transaction.transaction_names[index].tds}</div>
                                                        </div>
                                                        <div className='col-md-4'>
                                                            <label>Gross</label>
                                                            <div className='form-control'>{transaction.transaction_names[index].gross}</div>
                                                        </div>
                                                        <div className='col-md-4'>
                                                            <label>Remarks</label>
                                                            <div className='form-control'>{transaction.transaction_names[index].remarks}</div>
                                                        </div>
                                                    </div>
                                                ))}
                                            </div>
                                            <div className='row' style={{ margin: "0" }}>
                                                <div className='col-md-4'>
                                                    <label>Net Amount</label>
                                                    <div className='form-control'>{transaction.transaction_info[0].net_amount}</div>
                                                </div>
                                                <div className='col-md-4'>
                                                    <label>Bank Account Number</label>
                                                    <div className='form-control'>{transaction.transaction_info[0].bank_account_number}</div>
                                                </div>
                                                <div className='col-md-4'>
                                                    <label>Bank IFSC Code</label>
                                                    <div className='form-control'>{transaction.transaction_info[0].bank_ifsc_code}</div>
                                                </div>
                                                <div className='col-md-4'>
                                                    <label>Bank Account Name</label>
                                                    <div className='form-control'>{transaction.transaction_info[0].bank_account_name}</div>
                                                </div>
                                                <div className='col-md-4'>
                                                    <label>Remarks</label>
                                                    <div className='form-control'>{transaction.transaction_info[0].remarks}</div>
                                                </div>
                                                <div className="col-xl-12 col-lg-12 col-xxl-12 col-sm-12">
                                                    <div className="card bg-light mt-3 mb-2" style={{ height: "fit-content" }}>
                                                        <div className="card-header">
                                                            <h4 className="card-title">File Uploads</h4>
                                                        </div>
                                                        <div className="card-body row">
                                                            {(transaction == null || isLoading) ? <ScaleLoader cssOverride={{ "display": "flex", "justifyContent": "center", "alignItems": "center" }} /> :
                                                                (transaction.uploads == null) ? <div>No file uploads for the selected bill.</div> : (
                                                                    transaction.uploads.map(value => (<div style={{ "width": "fit-content", "margin": "10px" }}><a target="_blank" className='btn btn-dark' href={"https://api.flickanalytics.com/lalsalaamAPIs/uploads/" + value}>{value}</a></div>))

                                                                )}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default ViewTransactionInfo